import E2eSeedCard from '../../../components/admin/E2eSeedCard';
import TestBankdateienCard from '../../../components/admin/TestBankdateienCard';
import SimulationCard from '../../../components/admin/SimulationCard';

/**
 * Testdaten — **nur auf dem Testsystem** (`E2E_SEED_ENABLED`, live immer aus).
 *
 * Die Karte saß vorher auf der Unternehmensübersicht und war damit praktisch nur über
 * die URL zu finden. Seit dem Testing-Modul steht sie neben den Tickets — Testdaten
 * und Testmeldungen gehören an denselben Ort. Wo der Schalter aus ist, blendet
 * `/me/permissions` den Menüpunkt aus.
 */
export default function TestDataPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold leading-7">Testdaten</h1>
        <p className="text-muted-foreground">
          Ein bekannter Datenstand für manuelle Testsitzungen — in einem eigenen Standort,
          der echte Bestand bleibt unberührt.
        </p>
      </div>
      <E2eSeedCard fallback={(
        <div className="rounded-lg border border-dashed p-6 text-sm text-muted-foreground">
          Testdaten sind auf diesem System nicht freigeschaltet
          (<code>E2E_SEED_ENABLED</code>). Auf dem Produktivsystem bleibt das so.
        </div>
      )} />
      <SimulationCard />
      <TestBankdateienCard />
    </div>
  );
}
